import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79a9d277"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-right-full-page-notification-section" }
const _hoisted_2 = { class: "modal-dialog-right" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "image-icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "body-title"
}
const _hoisted_9 = {
  key: 1,
  class: "body-title-timeout"
}
const _hoisted_10 = { class: "body-description" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "btn-content-text" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['modal-right-full-page-notification', _ctx.modalOptions.classNameHeader, 'show', {hide: _ctx.isClose}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.modalOptions?.image === _ctx.ModalImage.WARNING_NO_INTERNET_ICON)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.noInternetBase64Icon
                  }, null, 8, _hoisted_6))
                : (_ctx.modalOptions?.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.getImagePath(_ctx.modalOptions.image)
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true)
            ]),
            (_ctx.modalOptions?.body?.title !== 'ทำรายการเกินเวลากำหนด')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalOptions.body?.title), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.modalOptions?.body?.title === 'ทำรายการเกินเวลากำหนด')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalOptions.body?.title), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                innerHTML: _ctx.modalOptions.body?.description
              }, null, 8, _hoisted_11)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalOptions.actionOptions, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "btn",
                style: _normalizeStyle({color: item.color ? item.color : '#424242', backgroundColor: item.backgroundColor ? item.backgroundColor : '#E8E8E8', borderColor: item.backgroundColor ? item.backgroundColor : '#E8E8E8'}),
                onClick: $event => (item?.action ? item.action() : _ctx.closeModal())
              }, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(item.text ? item.text : 'Close'), 1)
              ], 12, _hoisted_13))
            }), 256))
          ])
        ])
      ])
    ], 2)
  ]))
}